import { View } from 'foundations-components/components/View';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import { ScreenReaderOnly } from 'foundations-components/transitional/components/ScreenReaderOnly';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const VariantsInProgressNotificationBadge = ({
  count,
  hasHadRequestsInProgress,
  _instancePrefix,
  children
}) => /*#__PURE__*/_jsxs(View, {
  position: "relative",
  "data-test-id": "variants-in-progress-badge",
  children: [children, count > 0 && /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "personalizationLib.variantSelect.aiVariants.tooltip",
      options: {
        count
      }
    }),
    children: /*#__PURE__*/_jsx(StatusDot, {
      "data-test-id": "variants-in-progress-status-dot",
      position: "absolute",
      transform: "translate(-50%, -50%)",
      color: "fill-accent-magenta-default"
    })
  }), (hasHadRequestsInProgress || count > 0) && /*#__PURE__*/_jsx(ScreenReaderOnly, {
    "aria-live": "polite",
    id: `${_instancePrefix}--notification`,
    "data-test-id": "variants-in-progress-screen-reader",
    children: count > 0 ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "personalizationLib.variantSelect.aiVariants.ariaLabel.inProgress",
      options: {
        count
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "personalizationLib.variantSelect.aiVariants.ariaLabel.noneInProgress"
    })
  })]
});
export default VariantsInProgressNotificationBadge;